import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import scholarship_app from '../RCWB 2025-26 Teacher Grant Application.pdf';

const margin = '5px';
// const rotary_blue = '#005daa';
const useStyles = makeStyles({
    button1: {
        margin: margin,
        // backgroundColor: '#005daa',
        // '&:hover': { backgroundColor: '#0044aa' }
    },
    button2: {
        margin: margin,
        backgroundColor: 'red',
        '&:hover': { backgroundColor: '#aa0000' }
    }
});

export default function Grant() {
    const classes = useStyles();
    return (
        <React.Fragment>
            <h1 style={{ fontWeight: 'bold' }}>Teacher Grant</h1>
            <ul className='test'>
              <li>School must be located on the West Bank of Jefferson Parish.</li>
              <li>Individual teacher grants up to $1,000.00</li>
              <li>Applications are due by <span style={{ fontWeight: 'bold' }}>September 15, 2025</span></li>
            </ul>
            <Button className={classes.button1} color='primary' variant='contained' onClick={() => {
                window.open(scholarship_app, '_blank')
            }}>Download Application</Button>
        </React.Fragment>
    );
}
